import React from 'react';
import {
  AppNameSectionWrapper,
  BreadcrumbsPageName,
  CategoryTitleWrapper,
  PageHeaderSectionWrapper,
} from './styles';
import { Text } from '@amzn/storm-ui';
import { connect } from 'react-redux';
import {
  SelectedToolbarItem,
  selectLandingAppName,
  selectRenderTagInPageName,
  selectSelectedToolbarItem,
  updateLandingAppName,
} from 'src/features/nav/store/slice';
import { RootState } from 'src/app/store';
import { useBreadcrumbTruncationContext } from '../BreadcrumbIA2/BreadcrumbTruncationContext';
import {
  LANDING_PLACEMENT,
  LandingAppIcon,
} from 'src/commons/components/LandingAppIcon/LandingAppIcon';
import { selectIsSpoofing } from '../../store/slice';
import { Flag } from 'src/app/slice';
import { LaunchFlag } from 'src/commons/components/LaunchFlag/LaunchFlag';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

interface AppNameSectionProps {
  chromeConfigAppName: string;
  selectedToolbarItem: SelectedToolbarItem | undefined;
  isMobile?: boolean;
  pageTitleFlag: Flag | null;
  landingAppName: string;
  isSpoofing: boolean;
  updateLandingAppName: (...args: any[]) => any;
}

export const AppNameSection: React.FC<AppNameSectionProps> = ({
  chromeConfigAppName,
  selectedToolbarItem,
  isMobile = false,
  pageTitleFlag,
  landingAppName,
  isSpoofing,
  updateLandingAppName,
}) => {
  const { pageTitleRef } = useBreadcrumbTruncationContext();
  let url,
    category,
    appKeyName,
    selectedAppName,
    shouldDisplayCategory,
    isInternal;
  let shouldRenderCategory;

  if (selectedToolbarItem) {
    ({
      url,
      category,
      appName: selectedAppName,
      appKeyName,
      shouldDisplayCategory,
      isInternal,
    } = selectedToolbarItem);
    shouldRenderCategory = shouldDisplayCategory && !isMobile;
  } else {
    url = window.location.href;
    shouldRenderCategory = false;
  }

  const appName = selectedAppName ?? chromeConfigAppName;
  let ariaLabel = `${appName}.`;
  ariaLabel = shouldRenderCategory ? `${category}: ${ariaLabel}` : ariaLabel;
  ariaLabel = pageTitleFlag?.type
    ? `${ariaLabel} ${pageTitleFlag.type}`
    : ariaLabel;
  const shouldShowLandingIcon = !isSpoofing && !isInternal && !!appKeyName;

  return (
    <AppNameSectionWrapper>
      <PageHeaderSectionWrapper
        aria-label={ariaLabel}
        href={url}
        ref={pageTitleRef}
        {...getTaktAttributes('page-title', chromeComponents.HEADER, {
          url: url,
        })}
      >
        <CategoryTitleWrapper>
          <BreadcrumbsPageName
            renderAs="span"
            color="inverted"
            size="base"
            weight="bold"
            data-ccx-e2e-id="aac-page-title"
          >
            {shouldRenderCategory && (
              <Text size="small" color="inverted" weight="regular">
                {category}
              </Text>
            )}
            {appName}
            {pageTitleFlag && (
              <LaunchFlag
                flag={{
                  ...pageTitleFlag,
                  isInverted: true,
                  isMobile: isMobile,
                }}
              />
            )}
          </BreadcrumbsPageName>
        </CategoryTitleWrapper>
      </PageHeaderSectionWrapper>
      {shouldShowLandingIcon && (
        <LandingAppIcon
          appName={appKeyName}
          landingAppName={landingAppName}
          tooltipLabel={appName}
          landingPlacement={LANDING_PLACEMENT.HEADER}
          updateLandingAppName={updateLandingAppName}
        />
      )}
    </AppNameSectionWrapper>
  );
};

const connector = connect(
  (state: RootState) => {
    return {
      selectedToolbarItem: selectSelectedToolbarItem(state),
      pageTitleFlag: selectRenderTagInPageName(state),
      landingAppName: selectLandingAppName(state),
      isSpoofing: selectIsSpoofing(state),
    };
  },
  (dispatch) => {
    return {
      updateLandingAppName: (category) =>
        dispatch(updateLandingAppName(category)),
    };
  },
);

export const ConnectedAppNameSection = connector(AppNameSection);
